module.exports = __webpack_public_path__ + "img/TZS09390.afc6922b.jpeg";